export const currencyIsoCodeSlugs = {
    EUR: 'EUR',
    GBP: 'GBP',
};
